import React, { useState, useEffect, useRef } from "react";
import * as Sentry from "@sentry/react";
import IFrame from "react-iframe";
import { useContext } from "react";
import { Context } from "../context";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { env as environment } from "../controllers/environment";
import Header from "./Header";
import Sidebar from "./Sidebar";
import ls from "localstorage-slim";

ls.config.encrypt = true;
const getInputEmail = () => String(ls.get("inputEmail"));
const Verification = ({ iframeRef }) => {
	const IFrameRef = useRef(null);
	const [statusUpdated, setStatusUpdated] = useState(false);
	const [checkMulti, setCheckMulti] = useState(false);
	const [ifrState, setIfrState] = useState(true);
	const [iframeUrl, setIframeUrl] = useState();
	// const [iframeItem, setIframeItem] = useState();
	const currentUrl = useLocation();
	const navigate = useNavigate();
	const {
		data,
		setData,
		inputEmail,
		buttonSelection,
		buttonStatus,
		setButtonStatus,
		btnStatusPost,
		setBtnStatusPost,
		extraBankButton,
		buttonIndex,
		resubmit,
		fullscreen,
		browser,
		OS,
	} = useContext(Context);
	console.log("Iframe::data====", data);

	var isSessionInitiated;

	// ==== Send logs to greyLog ======
	// Sent form-urlencoded, not JSON: a JSON POST from cbre.diro.io needs a CORS
	// preflight, which never reaches logs.diro.live, so every call failed with
	// "Network Error". Form bodies need no preflight and m46 already parses them.
	// No timestamp: form values are strings, so m46's gelf sets it on receipt.
	const sendLogs = async (shortMessage, fullMessage) => {
		var logMessage = new URLSearchParams({
			"version": "1.0",
			"host": "CBRE React",
			"short_message": shortMessage,
			"full_message": fullMessage,
			"_ENV": environment.environment,
		});

		axios
			.post("https://logs.diro.live/logs", logMessage)
			.then(function (response) {
				// handle success
				console.log(response);
				return;
			})
			.catch(function (error) {
				// handle error
				Sentry.captureException(error);
				console.log(error);
				// transaction.finish();
			});
	}
	useEffect(() => {
		if (!inputEmail) navigate("/buttons/" + getInputEmail());
		// === Set iframe urls ===
		if (buttonSelection === "bank_verify") {
			setIframeUrl(environment.bankButton + getInputEmail())
			isSessionInitiated = setTimeout(() => {
				const newWindow = window.open(environment.bankButton + getInputEmail(), '_blank');
				newWindow?.focus();
				navigate("/buttons/" + getInputEmail());
			}, 8000);
		};
		if (buttonSelection === "utility_verify") {
			setIframeUrl(environment.utilityButton + getInputEmail())
			isSessionInitiated = setTimeout(() => {
				const newWindow = window.open(environment.utilityButton + getInputEmail(), '_blank');
				newWindow?.focus();
				navigate("/buttons/" + getInputEmail());
			}, 8000);
		};


		// === Eventlistner for capture process ===
		window.addEventListener("message", iframeEventListner);
		// === Cleanup on unmount ===
		return () => {
			setIframeUrl();
			window.removeEventListener("message", iframeEventListner);
		};
	}, []);

	// === EventListener function ===
	const iframeEventListner = async (event) => {
		console.log("11111111", event?.data);
		const sessionId = event?.data?.sessionid;
		const buttonId = event?.data?.buttonid;
		if (sessionId) {
			// Sentry.captureMessage(`Verification started for ${event?.data?.sessionid}. Browser: ${browser}, OS: ${OS}`);
			sendLogs(`Verification started for ${event?.data?.sessionid}.`, `Verification started for ${event?.data?.sessionid}. Browser: ${browser}, OS: ${OS}`)
		}
		// === Event when a session is initiated ===
		if (event?.data?.progress_status === "session initiated") {
			// console.error("Terminate for ", sessionId);
			// navigate("/buttons/" + ls.get("inputEmail"));
			clearTimeout(isSessionInitiated);
		}
		// === Event when Exit button is clicked ===
		if (event.data === "Terminate session from guac") {
			// console.error("Terminate for ", sessionId);
			sendLogs(`Terminate`, `Terminate for ${sessionId}`)
			navigate("/buttons/" + getInputEmail());
		}
		// === Event when document is submitted successfully ===
		if (event?.data?.progress_status === "Submitted" && !statusUpdated) {
			// Sentry.captureMessage(`Post Message for ${sessionId}`);
			sendLogs(`Post Message`, `Post Message for ${sessionId}`)

			// console.error("Post Message Found for ", sessionId);
			console.log("inputEmail:IIIIIIII", inputEmail);
			console.log("buttonSelection::", buttonSelection);
			window.removeEventListener("message", iframeEventListner);
			// setTimeout(() => {
			// 	navigate("/buttons/" + ls.get("inputEmail"));
			// }, 5500);
			const json = {
				email: ls.get("inputEmail"),
				apikey: environment.apikey,
				sessionID: sessionId,
				buttonid: buttonId,
				status: buttonSelection,
				progress_status: "Submitted",
				statusUpdateFrom: "react",

				verificationDetails: {},
			};
			console.log("extrabank", extraBankButton);
			!extraBankButton && (json.incId = buttonIndex);
			resubmit && (json.resubmit = resubmit);

			!checkMulti &&
				(await axios.post(environment.statusupdate, json).then((res) => {
					// Sentry.captureMessage(`statusupdate api called for ${sessionId}`);
					sendLogs(`StatusUpdate`, `statusupdate api called for ${sessionId}`)
					setStatusUpdated(true);
					setButtonStatus(res?.data?.data);
					ls.set("buttonstatus", JSON.stringify(res?.data?.data));
					// setButonSelection();
					console.log("statusupdate::RES::", res.data);
					setData(res.data);
					setCheckMulti(false);

					setTimeout(() => {
						navigate("/buttons/" + getInputEmail());
					}, 1500);
				}).catch((err) => {
					console.log("statusupdate API failed", err);
					setTimeout(() => {
						// if(currentUrl.pathname === 'verification') {
						axios.post(environment.statusupdate, json).then((res) => {
							// Sentry.captureMessage(`statusupdate api called inside catch block for ${sessionId}.`);
							sendLogs(`StatusUpdate`, `statusupdate api called inside catch block for ${sessionId}.`)
							setStatusUpdated(true);
							setButtonStatus(res?.data?.data);
							ls.set("buttonstatus", JSON.stringify(res?.data?.data));
							// setButonSelection();
							console.log("statusupdate::RES::", res.data);
							setData(res.data);
							setCheckMulti(false);

							setTimeout(() => {
								navigate("/buttons/" + getInputEmail());
							}, 1500);
						}).catch((err) => {
							setTimeout(() => {
								navigate("/buttons/" + getInputEmail());
							}, 1500);
						})
						// }
					}, 3000);
				}));
			extraBankButton && setCheckMulti(true);
			setIfrState(true);
		}
	};
	// if (ifrState) {
	// 	setIfrState(false);
	// 	window.addEventListener("message", iframeEventListner);
	// }
	// useEffect(() => {
	// 	iframeEventListner();
	// }, []);

	return (
		<div className={`iframe_wrapper ${window.location.href.includes("/verification") && 'iframe_wrapper_mobile'}`}>
			{/* {!fullscreen && <Header />} */}
			{/* <Header redirect={true} page={"verification"} iframe={IFrameRef} /> */}
			<Sidebar flScreen={true} />
			{/* <div className="ifr_wr"> */}
			<div className="iframe" ref={iframeRef}>
				<IFrame
					url={iframeUrl}
					width="100%"
					height="100%"
					frameBorder="0"
					id="ifr"
					className="iframe-element"
					display="block"
					allow="clipboard-read *; clipboard-write *"
				// onLoad={handleIframe}
				/>
			</div>
		</div>
		// </div>
	);
};

export default Verification;
